import { render } from "./wokerDetail20.vue?vue&type=template&id=b548e6e2&scoped=true"
import script from "./wokerDetail20.vue?vue&type=script&lang=js"
export * from "./wokerDetail20.vue?vue&type=script&lang=js"

import "./wokerDetail20.vue?vue&type=style&index=0&id=b548e6e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b548e6e2"]])

export default __exports__